import React, { useState } from 'react';
import axios from 'axios';
import './styles/MFA.css';

interface MFAProps {
    email: string;
    onSuccess: () => void;
}

const MFA: React.FC<MFAProps> = ({ email, onSuccess }) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await axios.post('/api/verify-mfa', { email, code });
            if (res.data.message === 'MFA verified') {
                onSuccess();
            } else {
                setError(res.data.error || 'Verification failed');
            }
        } catch (err: any) {
            setError(err.response?.data?.error || 'Verification failed');
        }
        setLoading(false);
    };

    return (
        <div className="mfa-dialog">
            <h2>Multi-Factor Authentication</h2>
            <p>Enter the 6-digit code sent to your email.</p>
            <form onSubmit={handleVerify}>
                <input
                    type="text"
                    maxLength={6}
                    pattern="\d{6}"
                    value={code}
                    onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
                    placeholder="Enter code"
                    required
                    className="mfa-input"
                />
                <button type="submit" disabled={loading || code.length !== 6} className="mfa-button">
                    {loading ? 'Verifying...' : 'Verify'}
                </button>
                {error && <div className="mfa-error">{error}</div>}
            </form>
        </div>
    );
};

export default MFA;